var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgChild = function SvgImgChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8566",
    d: "M28.63 69.787c15.812 0 28.63-12.818 28.63-28.63s-12.818-28.63-28.63-28.63S0 25.345 0 41.157s12.818 28.63 28.63 28.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M20.53 34.817a2.54 2.54 0 0 0-.97 3.45 2.54 2.54 0 0 0 3.45.97c1.22-.68 1.65-2.23.97-3.45a2.54 2.54 0 0 0-3.45-.97M37.13 32.397a2.54 2.54 0 0 0-3.45-.97 2.54 2.54 0 0 0-.97 3.45 2.54 2.54 0 0 0 3.45.97c1.22-.68 1.65-2.23.97-3.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D16450",
    d: "m33.258 44.25-4.755 1.262a1.8 1.8 0 0 0 .922 3.48l4.756-1.261a1.8 1.8 0 1 0-.923-3.48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE6C",
    d: "m8.715 17.82 23.212-6.22C30.21 5.195 23.619 1.394 17.212 3.11 10.807 4.826 7 11.413 8.715 17.82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE6C",
    d: "m10.38 14.897 26.3-7.05c1.28-.34 2.6.42 2.94 1.7s-.42 2.6-1.7 2.94l-26.3 7.05c-1.28.34-2.6-.42-2.94-1.7s.42-2.6 1.7-2.94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    d: "M59.07 79.807c9.95 0 18.02-8.07 18.02-18.02s-8.07-18.02-18.02-18.02-18.02 8.07-18.02 18.02 8.07 18.02 18.02 18.02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m61.9 61.787 3.96-3.96c.78-.78.78-2.05 0-2.83s-2.05-.78-2.83 0l-3.96 3.96-3.96-3.96c-.78-.78-2.05-.78-2.83 0s-.78 2.05 0 2.83l3.96 3.96-3.96 3.96a2.004 2.004 0 1 0 2.84 2.83l3.96-3.96 3.96 3.96c.39.39.9.59 1.42.59s1.02-.2 1.42-.59c.78-.78.78-2.05 0-2.83l-3.96-3.96z"
  })));
};
export default SvgImgChild;